/** @format */

import {
	AppProductReviewState,
	openProductReviewDrawer,
	ProductReviewAnalyticsService,
	ProductReviewDrawerType,
	SelectedProductReviewsProsCons,
	selectHighlyRatedFeatures,
	setSelectedFeature
} from '@product-reviews/data-access';
import { ChangeDetectorRef, Component, OnInit, Signal, viewChild } from '@angular/core';
import {
	HmfActionTextComponent,
	HmfDrawerComponent,
	HmfModalComponent
} from '@dsg-tech/homefield-angular';

import { BoldSpanPipe } from '../pipes/bold-span.pipe';
import { CommonModule } from '@angular/common';
import { DeviceService } from '@shared/data-access/services';
import { FeatureLabelPipe } from '../pipes/feature-label.pipe';
import { BypassSanitizationPipe } from '@shared/utils/pipes';
import { ProductReviewProsConsType } from 'libs/product-reviews/data-access/src/lib/model/product-review-pros-cons.enum';
import { Store } from '@ngrx/store';

@Component({
	selector: 'product-reviews-review-highly-rated-features-modal',
	standalone: true,
	imports: [
		BoldSpanPipe,
		CommonModule,
		FeatureLabelPipe,
		HmfActionTextComponent,
		HmfDrawerComponent,
		HmfModalComponent,
		BypassSanitizationPipe
	],
	templateUrl: './review-highly-rated-features-modal.component.html',
	styleUrl: './review-highly-rated-features-modal.component.scss'
})
export class ReviewHighlyRatedFeaturesModalComponent implements OnInit {
	modal: Signal<HmfModalComponent> = viewChild.required('modal');
	drawer: Signal<HmfDrawerComponent> = viewChild.required('drawer');

	isModalOpen = false;
	isMobile = true;
	proFeatureType = ProductReviewProsConsType.PRO;

	constructor(
		private readonly changeDetectorRef: ChangeDetectorRef,
		private readonly store: Store<AppProductReviewState>,
		private readonly deviceService: DeviceService,
		private readonly analyticsService: ProductReviewAnalyticsService
	) {}

	highlyRatedForFeatures$ = this.store.select(selectHighlyRatedFeatures);

	ngOnInit() {
		this.isMobile = this.deviceService.isMobileBreakpointNew();
	}

	openHighlyRatedFeatures() {
		if (this.isMobile) {
			this.openDrawer();
		} else {
			this.openModal();
		}
		this.changeDetectorRef.detectChanges();
	}

	openDrawer() {
		this.drawer()?.openDrawer();
	}

	openModal() {
		this.modal()?.openModal();
	}

	openReviewsDrawer(selectedFeature: SelectedProductReviewsProsCons) {
		this.store.dispatch(setSelectedFeature({ selectedFeature }));

		this.store.dispatch(
			openProductReviewDrawer({ drawerType: ProductReviewDrawerType.REVIEWS })
		);

		if (this.isMobile) {
			this.drawer()?.closeDrawer();
		} else {
			this.modal()?.closeModal();
		}

		this.trackHighlyRatedFilterClick();
	}

	private trackHighlyRatedFilterClick() {
		const payload = {
			event: 'RatingsAndReviewsInteraction',
			value: 'HighlyRatedFor',
			details: 'ReviewFilterLink'
		};

		this.analyticsService.fireReviewAnalytics<{ [key: string]: string }>({
			name: 'multiUseAnalyticsEvent',
			payload
		});
	}
}
